/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:2464c18f-3d5d-40ed-9bdd-0bd7a442ad36",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_fUiX0Rhoc",
    "aws_user_pools_web_client_id": "2s2djdegfucokmnq8fajhuna6q",
    "oauth": {
        "domain": "gradadmissionshubaa0d04c1-aa0d04c1-staging.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://main.d3qg8qn14f45no.amplifyapp.com/",
        "redirectSignOut": "https://main.d3qg8qn14f45no.amplifyapp.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS"
};


export default awsmobile;
